import { useCallback } from 'react';
import { List, type RowComponentProps } from 'react-window';

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@app/shared/ui/atoms/Common';
import { SelectOption } from '@app/shared/types/common';

interface ProfileSelectVirtualizedProps {
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder: string;
  isDisabled?: boolean;
  itemSize?: number;
  listHeight?: number;
}

export function ProfileSelectVirtualized({
  value,
  onChange,
  options,
  placeholder,
  isDisabled = false,
  itemSize = 35,
}: ProfileSelectVirtualizedProps) {
  const RowComponent = useCallback(
    ({ index, style }: RowComponentProps) => {
      const item = options[index];
      return (
        <SelectItem key={item.value} value={item.value} style={style}>
          {item.label}
        </SelectItem>
      );
    },
    [options]
  );

  return (
    <Select value={value} onValueChange={onChange} disabled={isDisabled}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder}>
          {options.find((o) => o.value === value)?.label}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <List
          rowComponent={RowComponent}
          rowCount={options.length}
          rowHeight={itemSize}
          rowProps={{ options }}
          className="scrollbar-hide min-h-[175px]"
        />
      </SelectContent>
    </Select>
  );
}
